export default {
  getList(state) {
    return state.list;
  },

  getBizRequestInfo(state) {
    return state.bizRequestInfo;
  },

  getPageInfo(state) {
    return state.pageInfo;
  }
};
